"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TREE_PAGE_LAYOUT_ELEMENT_TYPES = exports.TREE_PAGE_LAYOUT_TYPE = void 0;
exports.TREE_PAGE_LAYOUT_TYPE = "tree";
exports.TREE_PAGE_LAYOUT_ELEMENT_TYPES = {
    NODE: "node",
    REMOTE: "remote",
    CMS_TEMPLATE: "cms-template",
};
